import React from 'react';
import PropTypes from 'prop-types';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';
import screenResolution from '../../utils/screen-resolution';
import {
  PageContainer,
  PageTitle,
  PageHeader,
} from './css';
import utils from '../../utils/utils';
import Row from '../ReactComponent/Row';
import Column from '../ReactComponent/Column';
import ShipmentsWidget from '../../lib/ui/widgets/Shipments/ShipmentsWidget';
import QuotesWidget from '../../lib/ui/widgets/Quotes/QuotesWidget';
import NewsWidget from '../../lib/ui/widgets/News/NewsWidget';
import mockData from './mock';

const ViewUserDashboard = (props) => {
  const resolution = screenResolution();
  const { fields, accountNumbers, isAuthenticated } = props;
  const sitecoreData = (utils.isDisconnected) ? mockData : fields;
  const data = (sitecoreData.data) ? sitecoreData.data : null;
  const datasource = (data.datasourceItem) ? data.datasourceItem : null;
  const shipmentData = (datasource && datasource.children && datasource.children.length >= 3) ? datasource.children[3] : null;
  const quotesData = (datasource && datasource.children && datasource.children.length >= 2) ? datasource.children[2] : null;
  const newsData = (data && data.drsearch) ? data.drsearch : null;

  return (
    <div className="pt-4">
      <PageContainer>
        <PageHeader>
          {datasource.heading && datasource.heading.value
                && (
                <PageTitle>
                  <Text field={datasource.heading} />
                </PageTitle>
                )}
          {datasource.description && datasource.description.value
                && <RichText tag="p" field={datasource.description} />}
        </PageHeader>

        <Row>
          <Column $mobile={12} className="mt-5">
            {shipmentData
                        && (
                        <ShipmentsWidget
                          isAuthenticated={isAuthenticated}
                          accounts={accountNumbers}
                          fields={shipmentData}
                          resolution={resolution}
                          scrollbarheight="8px"
                          paddingicons="0 0 0 40px"
                          iconsheight="18px"
                        />
                        )}
            {quotesData
                        && (
                        <QuotesWidget
                          isAuthenticated={isAuthenticated}
                          accounts={accountNumbers}
                          fields={quotesData}
                          resolution={resolution}
                          scrollbarheight="8px"
                          paddingicons="0 0 0 40px"
                          iconsheight="18px"
                        />
                        )}

          </Column>
        </Row>
      </PageContainer>

      {newsData && newsData.results && newsData.results.items
            && <NewsWidget fields={sitecoreData} resolution={resolution} />}
    </div>
  );
};

const mstp = (state) => ({
  isAuthenticated: state.profile.isAuthenticated,
  division: state.profile.division,
  userId: state.profile.userId,
  accountNumbers: state.profile.accountNumbers,
});

ViewUserDashboard.propTypes = {
  fields: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  accountNumbers: PropTypes.array,
};

export default connect(mstp)(ViewUserDashboard);
